__turbopack_context__.v({
  "announcementBar": "AnnouncementBar-module-scss-module__TAKDWq__announcementBar",
  "announcementBar--hidden": "AnnouncementBar-module-scss-module__TAKDWq__announcementBar--hidden",
  "announcementBar--hide": "AnnouncementBar-module-scss-module__TAKDWq__announcementBar--hide",
  "close-btn": "AnnouncementBar-module-scss-module__TAKDWq__close-btn",
  "content": "AnnouncementBar-module-scss-module__TAKDWq__content",
  "size-1": "AnnouncementBar-module-scss-module__TAKDWq__size-1",
  "size-2": "AnnouncementBar-module-scss-module__TAKDWq__size-2",
  "size-3": "AnnouncementBar-module-scss-module__TAKDWq__size-3",
  "size-4": "AnnouncementBar-module-scss-module__TAKDWq__size-4",
  "size-5": "AnnouncementBar-module-scss-module__TAKDWq__size-5",
  "size-6": "AnnouncementBar-module-scss-module__TAKDWq__size-6",
});
